<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          :text="site.menu_game_text"
          :redirect_name="redirect_name"
        />
      </v-col>
    </v-row>

    <v-container class="pt-0 mt-2">
      <v-row class="mt-1">
        <v-col
          v-for="(item, index) in dataItems"
          :key="index"
          class="px-2 py-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              outlined
              elevation="1"
              width="100%"
              style="border: none"
              @click="redirectTo(item)"
              :disabled="checkRemindDate(item.remind_date, item.start_date)"
            >
              <div
                v-if="item.limit_reached"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("limitReached") }}</div>
              </div>
              <div
                v-else-if="checkRemindDate(item.remind_date, item.start_date)"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("textComingSoon") }}</div>
              </div>

              <v-img
                :lazy-src="require('@/assets/images/image.png')"
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                :src="item.image_url"
              >
              </v-img>

              <p
                v-if="item"
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.name }}
              </p>
              <v-skeleton-loader
                v-else
                type="list-item-two-line"
              ></v-skeleton-loader>

              <div
                v-if="!checkConditionEntryPassFree(item)"
                class="bottomleft mt-auto mb-0 text-start text-subtitle-2 pl-0 d-flex align-center"
              >
                <div style="width: 36px; min-width: 36px">
                  <div v-if="item.input_type == 'point'">
                    <PointSymbol
                      v-if="Array.isArray(item.point) && item.point.length > 0"
                      :type="item.point[0].point_type_type"
                      :symbol="item.point[0].point_type_symbol"
                      :color="item.point[0].point_type_color"
                      :is_display="true"
                      :outlined_box="false"
                      :size="28"
                    />
                  </div>
                  <v-icon v-else :color="site.color"
                    >mdi-ticket-confirmation-outline</v-icon
                  >
                </div>
                <div class="pr-2">
                  <p
                    class="mb-0"
                    style="font-size: 14px; line-height: 1"
                    :style="{
                      color: site.color,
                    }"
                    v-snip="{ lines: 2 }"
                  >
                    {{ getConditionEntryPass(item) }}
                  </p>
                </div>
              </div>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="!dataItems.length">
      <v-img
        class="white--text mx-auto mt-10 empty"
        :src="require('@/assets/images/out-of-stock.png')"
        max-width="200px"
      >
      </v-img>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>
    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "@/components/headerTextBg.vue";
import moment from "moment";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    InfiniteLoading,
    HeaderTextBg,
    PointSymbol,
  },
  data() {
    return {
      dataItems: [],
      infiniteId: +new Date(),
      redirect_name: "main",
    };
  },

  mounted() {},

  methods: {
    infiniteHandler($state) {
      this.isAppLoading(true);
      Axios.get("gamification/getGamification", {
        params: {
          cursor: this.next_page_url,
        },
      })
        .then(({ data }) => {
          if (data.data.length) {
            let has_more = data.has_more;
            this.dataItems = this.dataItems.concat(data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },

    redirectTo(item) {
      this.$router.push({
        name: "gamification-detail",
        params: { id: item.id },
      });
      const test = true;
      if (test) return;

      if (moment().isBefore(item.start_date, "day")) {
        this.$swal.fire({
          icon: "info ",
          text: this.$t("messageActivityUpcoming"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      this.$router.push({
        name: "gamification-detail",
        params: { id: item.id },
      });
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    checkRemindDate(remindDate, startDate) {
      if (!remindDate) return false;
      let remindDateMoment = moment(remindDate).startOf("day");
      let startDateMoment = moment(startDate).startOf("day");
      let currentDateMoment = moment().startOf("day");
      if (startDateMoment.isSameOrBefore(currentDateMoment)) return false;
      return remindDateMoment.isBefore(startDateMoment);
    },
    getConditionEntryPass(param) {
      let text = `-`;
      const input_type = param.input_type;
      const point = param.point;
      const reward_name = param.reward_name;
      if (input_type == "point") {
        if (Array.isArray(point) && point.length > 0 && point[0].point) {
          text = `${this.commaPoint(point[0].point)} ${
            point[0].point_type_name
          }`;
        }
      } else if (input_type == "reward" && reward_name) {
        text = `${reward_name}`;
      }
      return text;
    },
    checkConditionEntryPassFree(param) {
      let isFree = false;
      const input_type = param.input_type;
      const point = param.point;
      if (input_type == "point") {
        if (
          !point ||
          (Array.isArray(point) && point.length > 0 && !point[0].point)
        ) {
          isFree = true;
        }
      }
      return isFree;
    },
  },
  created() {},
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 12px;
  font-size: 18px;
}
.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  /* background-color: #00000099; */
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
  width: 75%;
  text-align: center;
}
</style>
